import { attributes, define } from "@type-r/models";
import { globalStore } from "api";
import { Loading } from "lqx-react/src";
import React from "react";
import { PendingActionsInvoices } from "../../api";
import { OpenItems } from "../../common/open-items";

@define 
export class BrokenPromiseInvoicesState extends attributes({
    brokenPromiseInvoices: [PendingActionsInvoices],
    isReady: Boolean
}){
    async fetch(){   
        const brokenInvoices = await PendingActionsInvoices.fetchBrokenPromiseInvoices();
        this.brokenPromiseInvoices.set(brokenInvoices);

        this.brokenPromiseInvoices.updateEach(element => {
            let customer = globalStore.getRelationshipById(element.relationshipId).Customer;
            element.customerName = customer.companyName;
            element.customerExternalId = customer.externalRelationshipId;
        });

        return this;
    } 

    getCount(){
        return this.brokenPromiseInvoices.reduce((curr:number, sum) => curr + (sum ? sum.count : 0), 0);
    }
}

export const BrokenPromiseInvoices = ({ state }: { state: BrokenPromiseInvoicesState }) => {


    return (
        state.isReady ? <>
                <OpenItems
                    title={`Open Items - (${state.getCount()})`}
                    invoices={state.brokenPromiseInvoices as any}
                    linkUrl='/invoices/statement'
                    bucket='all'
                    hasBrokenPromise={true}/>
            </> : <Loading />
    );
}
